import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { GenericService } from '../../services/generic.service';

@Component({
  selector: 'app-rodape',
  templateUrl: './rodape.component.html',
  styleUrls: ['./rodape.component.scss']
})
export class RodapeComponent implements OnInit {

  data: any;

  constructor(
    private genericService: GenericService
  ) { }

  ngOnInit(): void {
    //this.getData();
  }

  getData() {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
      "url": "Links Uteis",
      "parameters": {
        "$orderby": "Ordenar"
      }
    };

    this.genericService.getGenericv2Search(body, headers).subscribe(result => {
      this.data = result;
      this.data.sort();
      console.log(this.data)
    })
  }

}
